module.exports = "https://assets.calmac.co.uk/scripts/apps/site-services/1.7/img/info.svg";